module.exports = __webpack_public_path__ + "img/docs.a6de88c5.png";